import lazyGettext from 'js-utils/lazy-gettext';

/* GDPR Modal */
export const GDPR_MODAL_HEADER = lazyGettext('Get alerts for new events');
export const GDPR_MODAL_DESCRIPTION = lazyGettext('Receive marketing notifications about the latest news from this organizer');
export const GDPR_ACCEPT_COPY = lazyGettext('OK');
export const GDPR_REJECT_COPY = lazyGettext('No, thanks');
export const SAVE_ORGANIZER_FOLLOW_PREFERENCE_ERROR = lazyGettext('There was an issue saving your preference.');
export const GDPR_COLLECTION_MODAL_HEADER = lazyGettext('Get updates on this collection');
export const GDPR_COLLECTION_MODAL_DESCRIPTION = lazyGettext('Receive marketing notifications when new events are added to this collection');
